// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"PaymentStatus_loaderContainer__ZiFi8"};